export default function Empathy() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-10">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="section-title mb-6">
          LPを作りたいけど、
          <br className="sm:hidden" />
          こんな悩みはありませんか？
        </h2>
        <p className="text-base md:text-lg text-textMuted leading-relaxed">
          制作会社に頼むと高い。自分で作るのはむずかしい。
          <br className="hidden md:block" />
          ツールを触っても途中で止まってしまう。
          <br className="hidden md:block" />
          ChatLP は、そんな悩みをチャットで進めるだけで解決しやすくするサービスです。
        </p>
      </div>
    </section>
  );
}
